var map = {
	"./blender.svg": 429,
	"./csharp.svg": 430,
	"./css.svg": 431,
	"./electron.svg": 432,
	"./html.svg": 433,
	"./illustrator.svg": 434,
	"./java.svg": 435,
	"./js.svg": 436,
	"./mongo.svg": 437,
	"./mysql.svg": 438,
	"./nextjs.svg": 439,
	"./node.svg": 440,
	"./php.svg": 441,
	"./python.svg": 442,
	"./react.svg": 443,
	"./tailwind.svg": 444,
	"./typescript.svg": 445,
	"./unity.svg": 446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;